import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';

const Modal = ({ modal }) => {

    const {
        showModal, ...modalProps
    } = modal;

    useEffect(() => {
        if (showModal) {
            Swal.fire({ ...modalProps });
        }
    }, [modalProps, showModal]);

    return <div/>;

};

const mapStateToProps = ({ modal }) => ({ modal });

export default connect(mapStateToProps)(Modal);
